import { useQuery } from '@apollo/client';

import type { EntityType } from 'bundles/unified-seo-content-common/types';
import type {
  EntityQueryConfigs,
  EntityQueryData,
  EntityQueryVariables,
} from 'bundles/unified-seo-content-common/utils/entityCardDataQueryUtils';
import { getDeferToCSRQueryOptions } from 'bundles/unified-seo-content-common/utils/index';

const useEntityCardData = <T extends EntityType>({ query, queryOptions, dataResolver }: EntityQueryConfigs<T>) => {
  const { data, loading, error } = useQuery<EntityQueryData<T>, EntityQueryVariables<T>>(query, {
    ...queryOptions,
    ...getDeferToCSRQueryOptions(),
  });

  if (error && !data) {
    return {
      data: undefined,
      loading,
    };
  }

  return {
    ...dataResolver(data),
    loading,
  };
};

export default useEntityCardData;
